export default __webpack_public_path__ + "static/media/hospital-1.b8816b80.png";